import { useState } from 'react';
import { ArrowUp } from 'lucide-react';

interface AddLessonInputProps {
  onSubmit: (message: string) => void;
}

const AddLessonInput = ({ onSubmit }: AddLessonInputProps) => {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = () => {
    if (inputValue.trim()) {
      onSubmit(inputValue.trim());
      setInputValue('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="bg-white border border-[#d4d6da] rounded-2xl p-3 flex flex-col justify-between w-full">
      <label className="text-xs text-muted-foreground mb-1.5 block" style={{ fontFamily: 'Lexend Deca' }}>
        What would you like to learn next?
      </label>
      <textarea 
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder="e.g., Advanced Python concepts, Spanish verb conjugation..."
        className="bg-transparent border-none outline-none resize-none text-black text-[15px] leading-normal h-[80px] placeholder:font-light"
        style={{ fontFamily: 'Lexend Deca' }}
      />
      
      <div className="flex justify-end items-center">
        <button
          onClick={handleSubmit}
          disabled={!inputValue.trim()}
          className="bg-black hover:bg-gray-800 text-white rounded-full w-[30px] h-[30px] flex items-center justify-center disabled:opacity-50 transition-colors"
        >
          <ArrowUp className="w-5 h-5" strokeWidth={1.67} />
        </button>
      </div>
    </div>
  );
};

export default AddLessonInput;

